/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetFinancialTransactionQueryResponse, GetFinancialTransactionPathParams, GetFinancialTransaction400, GetFinancialTransaction401, GetFinancialTransaction403, GetFinancialTransaction404, GetFinancialTransaction409, GetFinancialTransaction500 } from "../../types/financialHubController/GetFinancialTransaction.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetFinancialTransactionUrl(organizationId: GetFinancialTransactionPathParams["organizationId"], transactionId: GetFinancialTransactionPathParams["transactionId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/financial/transactions/${transactionId}` as const }
  return res
}

/**
 * @summary Get ledger transaction detail
 * {@link /api/organizations/:organizationId/financial/transactions/:transactionId}
 */
export async function getFinancialTransaction(organizationId: GetFinancialTransactionPathParams["organizationId"], transactionId: GetFinancialTransactionPathParams["transactionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFinancialTransactionQueryResponse, ResponseErrorConfig<GetFinancialTransaction400 | GetFinancialTransaction401 | GetFinancialTransaction403 | GetFinancialTransaction404 | GetFinancialTransaction409 | GetFinancialTransaction500>, unknown>({ method : "GET", url : getGetFinancialTransactionUrl(organizationId, transactionId).url.toString(), ... requestConfig })
  return res.data
}